import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const CREATE = "create";
const GET = "get";
const GETALL = "getall";
const DELETE = "delete";
const UPDATE = "update";

export default {
  createTestimonial(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },

  getTestimonial(payload) {
    return Repository.post(transformRoute(GET), payload);
  },

  getAllTestimonial(payload) {
    return Repository.post(transformRoute(GETALL), payload);
  },

  deleteTestimonial(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },

  updateTestimonial(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },
};

const transformRoute = (route) => {
  return `/testimonial/${route}`;
};
